<template>
  <div class="card" v-if ="produit">
    <header class="header-card">
      <p>
        {{ $t('demandeLogistique.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="level">
            <div class="level-left">
          <date-picker :dates='dates'
          :updateEndDateAtChangeStartDate="false"/>
       </div>
        <div class="level-right">
          <button class="button is-addOrEdit"
                  @click="popupAdd()"
                  type="submit"
                  :class="{ 'button-access-no-permission' :
                    !checkPermissions(permDemande.maj)}">
            {{ $t('catalogue.actions.ajoutDemandeLogistique') }}
          </button>
        </div>
      </div>
      <div >
        <p class="has-text-default has-text-weight-bold">
          {{ $t('produitFace.affectation.nbResultat',
          { nb: demandeFiltre.length }) }}
        </p>
        <hr class="mgt-20px mgb-20px">
        <div>
          <div v-for="(demande, $index) in demandeFiltre" :key="$index"
            class="mgt-20px">
            <div class="columns is-vcentered is-marginless">
              <div class="column ">
                <p class="has-text-weight-bold">Demande logistique</p>
                <p> {{demande.actionLogistique}}</p>
              </div>
              <div class="column is-narrow">
                <b-field :label="$t('demandeLogistique.patrimoine.date')">
                  <span class="is-size-7 has-text-default">
                    {{ demande.datePlanification | formatDate }}
                  </span>
                </b-field>
              </div>
              <div class="column is-2">
                <b-field :label="$t('demandeLogistique.patrimoine.etat')">
                  <span class="is-size-7 has-text-default">
                    {{ $t(importedFunction.getEtatDemande(demande))}}
                  </span>
                </b-field>
              </div>
              <div class="column is-2">
                <div v-if="demande.otsAffichages && demande.otsAffichages.length ==1">
                  <router-link-blank :to="{ name: 'c.logistique.ordre_travail-affichage',
                    params: { id: demande.otsAffichages[0].id } }"
                    class="lien"
                    :message="demande.otsAffichages[0].code">
                  </router-link-blank>
                </div>
              </div>
              <a @click=" popupSupp(demande)" class="is-pulled-right column is-narrow">
                <b-icon
                  icon="delete-forever"
                  type="is-danger"
                  :class="{ 'text-access-no-permission'
                  : !checkPermissions(permDemande.supprimer) || demande.estDansOtAffichage}">
                </b-icon>
              </a>
              <a @click=" popupUpdate(demande)" class="is-pulled-right column is-narrow">
                <b-icon
                  icon="pencil-box-outline"
                  type="is-success"
                  :class="{ 'text-access-no-permission'
                  : !checkPermissions(permDemande.maj) || demande.estDansOtAffichage}">
                </b-icon>
              </a>
            </div>
            <hr class="mgt-20px mgb-20px"
              v-if="$index + 1 !== produit.demandesLogistique.length">
          </div>
        </div>
        <footer>
        </footer>
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('demandeLogistique.popUpSuppression.title')"
        :messDescription="this.$t('demandeLogistique.popUpSuppression.message')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteDemande"/>
    </b-modal>
    <b-modal v-model="popUpModificationCreation" has-modal-card class="modal">
        <modificationCreationDemande
          @refreshList="refreshList"
          :demandeLogistique="ligneAModifier"
          :produit="produit">
        </modificationCreationDemande>
    </b-modal>

  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { DATE_MAX, DATE_MIN } from '@/configuration/general/dateConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import { deleteDemandeLogistique } from '@/api/logistique/demandeLogistique/index';
import { DEMANDE } from '@/configuration/logistique/permissionsLogistiqueConf';
import messageErreur from '@/services/general/messageErreur';
import formatDate from '@/services/general/formatDate';
import getEtatDemande from '@/services/logistique/demandeLogistique/getEtatDemandeLogistique';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import datePicker from '@/components/general/datePicker';
import modificationCreationDemande from './p_editionDemande';

const Permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'p_demandeLogistiques',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      finChargement: true,
      demandeASupp: null,
      popUpSuppression: false,
      creationDemandeParametre: {
        datePlanification: moment().toDate(),
        actionLogistique: '',
      },
      permDemande: DEMANDE,
      popUpModificationCreation: false,
      ligneAModifier: null,
      dates: {
        dateDebut: moment().weekday(0).toDate(),
        dateFin: null,
      },
      importedFunction: {
        getEtatDemande,
      },
    };
  },
  components: {
    popUpPrevention,
    modificationCreationDemande,
    datePicker,
    routerLinkBlank,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    demandeFiltre() {
      if (!this.finChargement) return [];
      this.tri();
      const dateDebut = formatIsoDate(this.dates.dateDebut ? this.dates.dateDebut : DATE_MIN);
      const dateFin = formatIsoDate(this.dates.dateFin ? this.dates.dateFin : DATE_MAX);
      return this.produit.demandesLogistique.filter(d => {
        return dateDebut <= d.datePlanification && d.datePlanification <= dateFin;
      });
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    refreshList(demande) {
      this.finChargement = false;
      const demandeEcran = this.produit.demandesLogistique.find(d => {
        return d.id === demande.id;
      });
      if (!demandeEcran) {
        this.produit.demandesLogistique.push(demande);
      } else {
        demandeEcran.datePlanification = demande.datePlanification;
        demandeEcran.actionLogistique = demande.actionLogistique;
        demandeEcran.demandeLogistiqueSelProduit = demande.demandeLogistiqueSelProduit;
      }
      this.tri();
      this.finChargement = true;
    },
    formatDate(date) {
      return formatDate(date);
    },
    popupSupp(demande) {
      if (!this.checkPermissions(this.permDemande.supprimer) || demande.estDansOtAffichage) {
        return;
      }
      this.demandeASupp = demande;
      this.popUpSuppression = true;
    },
    popupUpdate(demande) {
      if (!this.checkPermissions(this.permDemande.maj) || demande.estDansOtAffichage) {
        return;
      }
      this.ligneAModifier = demande;
      this.popUpModificationCreation = true;
    },
    popupAdd() {
      if (!this.checkPermissions(this.permDemande.maj)) {
        return;
      }
      this.ligneAModifier = null;
      this.popUpModificationCreation = true;
    },
    async deleteDemande() {
      const loadingComponent = this.$buefy.loading.open();
      this.finChargement = false;
      try {
        await deleteDemandeLogistique(this.demandeASupp.id);
        const indexDemandeASupp = this.produit.demandesLogistique.findIndex(d => {
          return this.demandeASupp.id === d.id;
        });
        if (indexDemandeASupp > -1) {
          this.produit.demandesLogistique
            .splice(indexDemandeASupp, 1);
        }
        this.tri();
        this.demandeASupp = null;
        this.popUpSuppression = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('demandeLogistique.popUpSuppression.success'));
        this.finChargement = true;
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        this.finChargement = true;
        throw (e);
      }
    },
    tri() {
      this.produit.demandesLogistique = this.produit.demandesLogistique.sort((a, b) => {
        return new Date(a.datePlanification) - new Date(b.datePlanification);
      });
    },
  },
};
</script>
